import { Fragment } from 'react';

export type ShopStep = 1 | 2 | 3 | 4;

const STEPS = ['ZAMÓWIENIE', 'KOSZULKA', 'DOSTAWA', 'PŁATNOŚĆ'] as const;
const NUMERALS = ['①', '②', '③', '④'] as const;

export function StepIndicator({ current }: { current: ShopStep }) {
  return (
    <div
      className="mono"
      style={{ fontSize: 11, letterSpacing: '.14em', color: 'rgba(var(--shop-muted-rgb),.6)' }}
    >
      {STEPS.map((label, i) => {
        const step = i + 1;
        return (
          <Fragment key={label}>
            {i > 0 && ' → '}
            <span
              style={{
                fontWeight: step <= current ? 700 : 400,
                color: step === current ? 'var(--orange)' : undefined,
              }}
            >
              {NUMERALS[i]} {label}
            </span>
          </Fragment>
        );
      })}
    </div>
  );
}
